import api from '../../services/content';
export default function (helper) {
  const _TYPES = {
    STORE_DELETE: `STORE_DELETE`
  };

  /**
   * Generated store module
   */
  helper.setApi(api);
  const types = helper.types('content');
  const state = helper.state();
  const getters = helper.getters();
  const actions = helper.actions({
    // Overwrite the getOne action to send the extra params without getting an API error
    getOne(context, params) {
      helper
        .log()
        .info(`[Store: Content}]: Get Content`, params);
      return new Promise((resolve, reject) => {
        return helper
        .api()
        .getOne(params)
        .then((response) => {
          helper
            .log()
            .info(`[Store: Content]: Got Content`, response.data);
          context.commit(types.STORE_GET, {
            params,
            result: response.data.data,
          });
          resolve(response.data.data);
        })
        .catch((error) => {
          helper
            .log()
            .info(`[Store: Lesson]: Error Getting content`, error);
            reject(error);
        })
      });
    },
  }, 'Content');
  const mutations = helper.mutations({
    [_TYPES.STORE_DELETE](state, data) {
      helper.utils.removeFromStateData(state, data.params);
      if (data.context) {
        helper.utils.updateStats(data.context, -1, 'content');
      }
    }
  }, types, state);

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}